import { observer } from 'mobx-react';
import { T } from '../../../../../../../Translations';
import clsx from 'clsx';

export interface Props {
  skipCommunications: boolean;
  setSkipCommunications: (skip: boolean) => void;
}

function SkipCommunications({ skipCommunications, setSkipCommunications }: Props) {
  return (
    <>
      <label className="font-semibold block">
        <T kind="Send Invitation Email to Invited Participants" />
      </label>
      <button
        onClick={() => setSkipCommunications(false)}
        className={clsx(
          skipCommunications ? 'text-teal-600 bg-white' : 'text-white bg-teal-600',

          'rounded-l text-teal-600 focus:ring-teal-600 border border-teal-600 mt-2 mr-0 px-10 py-2',
        )}
      >
        Yes
      </button>
      <button
        onClick={() => setSkipCommunications(true)}
        className={clsx(
          skipCommunications ? 'text-white bg-teal-600' : 'text-teal-600 bg-white',
          'rounded-r text-teal-600 focus:ring-teal-600 border border-teal-600 mt-2 mr-0 px-10 py-2 border-l-0',
        )}
      >
        No
      </button>
    </>
  );
}

export default observer(SkipCommunications);
